// Indonesian texts for src/pages/JobDetail.tsx
export default {
  // header & actions
  "Job not found": "Proses tidak ditemukan",
  "Pausing after the current files…": "Menjeda setelah file saat ini selesai…",
  "Pause": "Jeda",
  "Resumed from where it stopped": "Dilanjutkan dari titik terakhir",
  "Resume": "Lanjutkan",
  "Download ZIP": "Unduh ZIP",
  "Running again — files will be rebuilt": "Dijalankan lagi — file akan dibangun ulang",
  "Run again": "Jalankan lagi",
  "Summary": "Ringkasan",
  "Preview": "Pratinjau",
  "Files": "File",
  "Log": "Log",
  "Advanced": "Lanjutan",
  "Job": "Proses",
  "Started {when}": "Dimulai {when}",
  "● Live": "● Langsung",
  "Updating…": "Memperbarui…",
  "Cancel job": "Batalkan proses",
  "Downloaded files are kept": "File yang sudah diunduh tetap disimpan",
  "Cancel this job?": "Batalkan proses ini?",
  "Job cancelled": "Proses dibatalkan",
  "Retry failed files and rebuild": "Coba lagi file yang gagal dan bangun ulang",
  "Running again": "Dijalankan lagi",
  "Check quality again": "Periksa kualitas lagi",
  "Quality check started": "Pemeriksaan kualitas dimulai",
  "Delete files now": "Hapus file sekarang",
  "Remove this job's files from the server": "Hapus file proses ini dari server",
  "Delete this job's files from the server now? Download the ZIP first if you need it.": "Hapus file proses ini dari server sekarang? Unduh ZIP terlebih dahulu jika masih diperlukan.",
  "Files deleted from the server": "File dihapus dari server",
  "Open domain": "Buka domain",
  "This job stopped with an error": "Proses ini berhenti karena kesalahan",
  "Open log": "Buka log",

  // job types (TYPE_LABEL)
  "Recovery": "Pemulihan",
  "Analysis": "Analisis",
  "Quality check": "Pemeriksaan kualitas",
  "Visual check": "Pemeriksaan visual",
  "Deployment": "Deploy",

  // live progress (PHASES)
  "Select captures": "Pilih rekaman arsip",
  "Download": "Unduh",
  "Rebuild site": "Bangun ulang situs",
  "Check quality": "Periksa kualitas",
  "Package ZIP": "Kemas ZIP",
  "Read archive history": "Baca riwayat arsip",
  "Analyze versions": "Analisis versi",
  "Paused — press Resume to continue from here.": "Dijeda — tekan Lanjutkan untuk melanjutkan dari sini.",
  "Waiting for a free worker…": "Menunggu worker yang tersedia…",
  "{downloaded} downloaded · {missing} not archived · {failed} failed": "{downloaded} diunduh · {missing} tidak diarsipkan · {failed} gagal",
  "Estimating time remaining…": "Memperkirakan sisa waktu…",
  "About {time} left in this step": "Sekitar {time} lagi untuk langkah ini",
  "Estimated from the speed so far in this browser. The archive sometimes slows down, so treat it as a rough guide.": "Diperkirakan dari kecepatan sejauh ini di browser ini. Arsip terkadang melambat, jadi anggap sebagai perkiraan kasar.",

  // files notice
  "Files were deleted from the server": "File telah dihapus dari server",
  "They are only kept for a limited time. The results below stay available; use": "File hanya disimpan untuk waktu terbatas. Hasil di bawah tetap tersedia; gunakan",
  "to rebuild the ZIP and preview.": "untuk membangun ulang ZIP dan pratinjau.",
  "Available until {date} ({when})": "Tersedia hingga {date} ({when})",
  "Download the ZIP to keep the restored website. After this time its files are deleted from the server automatically.": "Unduh ZIP untuk menyimpan website yang dipulihkan. Setelah waktu ini, file-nya otomatis dihapus dari server.",

  // plain summary
  "Details": "Detail",
  "Status": "Status",
  "Finished": "Selesai",
  "Last message": "Pesan terakhir",
  "See archive history": "Lihat riwayat arsip",

  // recovery summary
  "Pages restored": "Halaman dipulihkan",
  "{n} selected for this date": "{n} dipilih untuk tanggal ini",
  "Older-version pages": "Halaman versi lama",
  "Kept in a separate folder": "Disimpan di folder terpisah",
  "Images, CSS & files": "Gambar, CSS & file",
  "{n} not archived": "{n} tidak diarsipkan",
  "Not available": "Tidak tersedia",
  "Pages without a capture for this date": "Halaman tanpa rekaman arsip untuk tanggal ini",
  "Results appear when the recovery finishes": "Hasil muncul setelah pemulihan selesai",
  "Quality checks": "Pemeriksaan kualitas",
  "Automatic checks of the restored website.": "Pemeriksaan otomatis pada website yang dipulihkan.",
  "Every page is from the chosen date or earlier": "Setiap halaman berasal dari tanggal yang dipilih atau lebih awal",
  "{n} newer pages detected": "{n} halaman yang lebih baru terdeteksi",
  "No leftover Wayback Machine links or toolbar": "Tidak ada sisa tautan atau toolbar Wayback Machine",
  "{n} references found": "{n} referensi ditemukan",
  "All restored pages open correctly": "Semua halaman yang dipulihkan terbuka dengan benar",
  "{n} pages returned an error": "{n} halaman mengembalikan kesalahan",
  "{n} internal links point to pages the archive does not have": "{n} tautan internal mengarah ke halaman yang tidak ada di arsip",
  "No broken internal links": "Tidak ada tautan internal yang rusak",
  "{n} images or files are referenced but not archived": "{n} gambar atau file dirujuk tetapi tidak diarsipkan",
  "No missing images or files": "Tidak ada gambar atau file yang hilang",
  "Still loads files from {n} other site(s)": "Masih memuat file dari {n} situs lain",
  "Loads nothing from other sites": "Tidak memuat apa pun dari situs lain",
  "{hosts} — enable “Recover files hosted on other sites” in domain settings, then Run again.": "{hosts} — aktifkan “Pulihkan file yang di-host di situs lain” di pengaturan domain, lalu Jalankan lagi.",
  "{n} spam page (gambling / adult / pharma) excluded": "{n} halaman spam (judi / dewasa / obat) dikecualikan",
  "{n} spam pages (gambling / adult / pharma) excluded": "{n} halaman spam (judi / dewasa / obat) dikecualikan",
  "{n} pages contain words often used by spam": "{n} halaman berisi kata-kata yang sering dipakai spam",
  "No spam content detected": "Tidak ada konten spam terdeteksi",
  "Review them in Files before publishing.": "Tinjau di tab File sebelum dipublikasikan.",
  "{n} page(s) look like a parked / for-sale page": "{n} halaman tampak seperti halaman diparkir / dijual",
  "{n} files failed to download": "{n} file gagal diunduh",
  "No download failures": "Tidak ada unduhan yang gagal",
  "Use Run again to retry them.": "Gunakan Jalankan lagi untuk mencobanya lagi.",

  // downloads
  "Downloads": "Unduhan",
  "Files were deleted from the server. Use Run again to rebuild them.": "File telah dihapus dari server. Gunakan Jalankan lagi untuk membangunnya ulang.",
  "Website ZIP · {size}": "ZIP website · {size}",
  "Contains the site, older versions and all reports. Upload the site folder as-is; no server config needed.": "Berisi situs, versi lama, dan semua laporan. Upload folder site apa adanya, tanpa perlu setting server.",
  "The ZIP is created at the end of the recovery.": "ZIP dibuat di akhir pemulihan.",
  "URL inventory": "Inventaris URL",
  "Every archived URL and what happened to it": "Setiap URL yang diarsipkan dan hasilnya",
  "SEO audit": "Audit SEO",
  "Titles, descriptions, canonicals and issues per page": "Judul, deskripsi, canonical, dan masalah per halaman",
  "Missing & failed files": "File hilang & gagal",
  "Pages and files that could not be restored": "Halaman dan file yang tidak dapat dipulihkan",
  "Broken links": "Tautan rusak",
  "Links and images pointing to missing pages": "Tautan dan gambar yang mengarah ke halaman yang hilang",
  "Recovery manifest": "Manifes pemulihan",
  "Technical list of every restored route": "Daftar teknis setiap rute yang dipulihkan",

  // what was restored
  "What was restored": "Yang dipulihkan",
  "Mode": "Mode",
  "Website version": "Versi website",
  "Snapshot": "Snapshot",

  // issue details
  "Broken internal links": "Tautan internal rusak",
  "Missing images & files": "Gambar & file hilang",
  "Files loaded from other sites": "File yang dimuat dari situs lain",
  "Outgoing links to other domains": "Tautan keluar ke domain lain",
  "page": "halaman",
  "target": "target",
  "host": "host",
  "count": "jumlah",
  "domain": "domain",

  // log
  "Activity log": "Log aktivitas",
  "Auto-scroll": "Gulir otomatis",
  "No entries yet.": "Belum ada entri.",

  // files
  "Search URL or page title": "Cari URL atau judul halaman",
  "Search files": "Cari file",
  "Type": "Jenis",
  "Pages and files": "Halaman dan file",
  "Pages only": "Hanya halaman",
  "Redirects": "Redirect",
  "Any result": "Semua hasil",
  "Downloaded": "Terunduh",
  "Not archived": "Tidak diarsipkan",
  "Failed": "Gagal",
  "Pending": "Menunggu",
  "No files match.": "Tidak ada file yang cocok.",
  "Page": "Halaman",
  "File": "File",
  "Redirect": "Redirect",
  "older version {n}": "versi lama {n}",
  "captured {date}": "direkam {date}",
  "newer capture used": "memakai rekaman arsip yang lebih baru",

  // preview
  "Preview not available": "Pratinjau tidak tersedia",
  "The files were deleted from the server. Use Run again to rebuild them.": "File telah dihapus dari server. Gunakan Jalankan lagi untuk membangunnya ulang.",
  "Preview not ready yet": "Pratinjau belum siap",
  "It becomes available once the website has been rebuilt.": "Pratinjau tersedia setelah website selesai dibangun ulang.",
  "Nothing to preview": "Tidak ada yang bisa dipratinjau",
  "Main site": "Situs utama",
  "Older version {n}": "Versi lama {n}",
  "/ (homepage) — or type a path, e.g. /about": "/ (beranda) — atau ketik path, mis. /about",
  "Path": "Path",
  "Go": "Buka",
  "Open in a new tab": "Buka di tab baru",
  "Restored website preview": "Pratinjau website yang dipulihkan",
  "The preview runs in an isolated sandbox: restored pages cannot access this dashboard or the internet.": "Pratinjau berjalan di sandbox terisolasi: halaman yang dipulihkan tidak dapat mengakses dasbor ini atau internet.",

  // redirects
  "Redirect approvals saved": "Persetujuan redirect disimpan",
  "Original redirects": "Redirect asli",
  "Redirects the old website used. They stay off until you approve them; only approve redirects to equivalent pages.": "Redirect yang dipakai website lama. Redirect tetap nonaktif sampai disetujui; setujui hanya redirect ke halaman yang setara.",
  "Save approvals": "Simpan persetujuan",
  "The archive has no redirects for this website.": "Arsip tidak memiliki redirect untuk website ini.",
  "approve {url}": "setujui {url}",
  "Saved. The site and ZIP are being rebuilt with these redirects.": "Tersimpan. Situs dan ZIP sedang dibangun ulang dengan redirect ini.",
  "Suggested redirects": "Saran redirect",
  "Old addresses (older versions, backlink targets, pages missing for this date) matched to the most similar restored page. Nothing is redirected until you approve it; pages are never sent to the homepage as a catch-all.": "Alamat lama (versi lama, target backlink, halaman yang hilang untuk tanggal ini) dicocokkan dengan halaman pulihan yang paling mirip. Tidak ada yang di-redirect sebelum disetujui; halaman tidak pernah dialihkan ke beranda sebagai tujuan umum.",
  "No confident matches. Old URLs without a similar page are better left as 404.": "Tidak ada kecocokan yang meyakinkan. URL lama tanpa halaman serupa sebaiknya dibiarkan 404.",
  "{n}% match": "{n}% cocok",
  "{n} backlinks": "{n} backlink",

  // before / after & visual check
  "Taking screenshots — this takes a minute or two": "Mengambil screenshot — butuh satu atau dua menit",
  "Before / after": "Sebelum / sesudah",
  "Left: the page as the Internet Archive captured it. Right: your restored copy. Drag the handle to compare.": "Kiri: halaman seperti yang direkam Internet Archive. Kanan: salinan hasil pemulihan. Geser pegangan untuk membandingkan.",
  "{n} more pages compared under Advanced → Visual check.": "{n} halaman lain dibandingkan di Lanjutan → Pemeriksaan visual.",
  "See how the restored homepage compares with the archived original.": "Lihat perbandingan beranda hasil pemulihan dengan aslinya di arsip.",
  "Create comparison": "Buat perbandingan",
  "Visual check started": "Pemeriksaan visual dimulai",
  "Compare the 10 most linked restored pages with how they looked in the archive.": "Bandingkan 10 halaman pulihan yang paling banyak ditautkan dengan tampilannya di arsip.",
  "Run visual check": "Jalankan pemeriksaan visual",
  "No screenshots yet.": "Belum ada screenshot.",
  "{n}% similar": "{n}% mirip",
  "Restored": "Hasil pulihan",
  "In the archive": "Di arsip",

  // deploy
  "Dry run started": "Uji coba dimulai",
  "Deployment started": "Deploy dimulai",
  "Rolled back": "Dikembalikan ke versi sebelumnya",
  "Deploy to a server": "Deploy ke server",
  "Upload the restored site to your own server over SSH. Nothing is overwritten; every upload is a new release you can roll back.": "Unggah situs yang dipulihkan ke server sendiri melalui SSH. Tidak ada yang ditimpa; setiap unggahan adalah rilis baru yang bisa dikembalikan.",
  "Available while the recovery's files are on the server.": "Tersedia selama file pemulihan masih ada di server.",
  "Server": "Server",
  "Port": "Port",
  "User": "Pengguna",
  "SSH key": "Kunci SSH",
  "Select…": "Pilih…",
  "No SSH keys found. Place a private key in {dir} (see docs/DEPLOYMENT.md).": "Tidak ada kunci SSH. Letakkan private key di {dir} (lihat docs/DEPLOYMENT.md).",
  "Destination folder": "Folder tujuan",
  "Trusted host key (SHA256:…)": "Kunci host tepercaya (SHA256:…)",
  "Replace an existing live folder (it is kept as a backup)": "Ganti folder live yang ada (disimpan sebagai cadangan)",
  "Dry run — only test the connection and show the plan": "Uji coba — hanya tes koneksi dan tampilkan rencana",
  "I own this content or have permission to publish it.": "Saya pemilik konten ini atau memiliki izin untuk memublikasikannya.",
  "Run a dry run?": "Jalankan uji coba?",
  "Deploy to {target}?": "Deploy ke {target}?",
  "Run dry run": "Jalankan uji coba",
  "Deploy": "Deploy",
  "History": "Riwayat",
  "No deployments yet.": "Belum ada deploy.",
  "dry run": "uji coba",
  "Switch back to {path}?": "Kembali ke {path}?",
  "Roll back": "Kembalikan",
} as Record<string, string>;
